import { useQuery } from "@apollo/client/react";
import { GET_LPP_PLANS } from "../graphql/salaries";

/**
 * Load the available LPP plans for specified CCT contract ID.
 * @param cctContractId
 */
export const useLoadContractLppPlans = (cctContractId?: string | null) => {
    const { data } = useQuery(GET_LPP_PLANS, {
        fetchPolicy: "cache-and-network",
        variables: {
            cctContractId: cctContractId as string,
        },
        skip: !cctContractId,
    });
    return data?.getLppPlans;
};
